(function ($) {
    'use strict';

    $.fn.auctionPoup = function (photoData) {
        const $self = $(this);
        const $popupTemplate = $('.js-popup-template');
        const albumData = photoData;

        let $popup;

        /**
         * Открыть попап из шаблона
         */
        const openPopup = function () {
            $popup = $popupTemplate.clone();
            $popup.appendTo('body');


            $('html').css('overflow', 'hidden');

            $popup.on('click', function (event) {
                let $target = $(event.target);

                if ($target.is($popup) || $target.closest('.js-popup-close').length) {
                    closePopup();
                } else if ($target.closest('.js-popup-prev').length) {
                    prevMedia();
                } else if ($target.closest('.js-popup-next').length) {
                    nextMedia();
                }
            });

            if (typeof $.fn.swipe === 'undefined') {
                return;
            }

            $popup.swipe({
                swipe: function (event, direction) {
                    switch (direction) {
                        case 'left':
                            nextMedia();
                            break;

                        case 'right':
                            prevMedia();
                            break;

                        default:
                            break;
                    }
                }
            });
        };

        /**
         * Закрыть попап
         */
        const closePopup = function () {
            $popup.remove();
            $('html').css('overflow', '');
        };

        /**
         * Перейти к предыдущему элементу альбома в попапе
         */
        const prevMedia = function () {
            if ($(document).find($popup).length === 0) {
                return;
            }

            setPopupContentByItemIndex($popup.data('currentIndex') - 1);
        };

        /**
         * Перейти к следующему элементу альбома в попапе
         */
        const nextMedia = function () {
            if ($(document).find($popup).length === 0) {
                return;
            }

            setPopupContentByItemIndex($popup.data('currentIndex') + 1);
        };

        /**
         * Установить контент попапа по индексу элемента альбома
         * @param {Number} index - индекс элемента альбома
         */
        const setPopupContentByItemIndex = function (index) {
            if (albumData.length === 0 || $(document).find($popup).length === 0) {
                return;
            }

            index = (index + albumData.length) % albumData.length; // зацикливаем список

            let currentItemData = albumData[index].full;

            $popup.data('currentIndex', index);

            if ($popup.find('img').length) {
                $popup.find('img').remove();
            }

            $popup
                .find('.js-popup-content')
                .css({
                    width: '',
                    height: ''
                })
                .append($('<img>', {
                    src: currentItemData.SRC,
                    alt: '',
                    loading: 'lazy',
                    attr: {
                        width: currentItemData.WIDTH,
                        height: currentItemData.HEIGHT
                    },
                    on: {
                        load: function () {
                            let maxWidth = $popup.width();
                            let maxHeight = $popup.height();
                            let xRatio = currentItemData.WIDTH / maxWidth;
                            let yRatio = currentItemData.HEIGHT / maxHeight;
                            let maxRatio = Math.max(xRatio, yRatio);

                            if (maxRatio > 1) {
                                $popup.find('.js-popup-content').css({
                                    width: currentItemData.WIDTH / maxRatio,
                                    height: currentItemData.HEIGHT / maxRatio
                                });
                            }
                        }
                    }
                }))
                .find('.js-popup-item-count')
                .text((index + 1) + '/' + albumData.length);
        };

        const init = function () {
            // клик по элементу альбома - открытие попапа
            $(document).on('click', '.js-eshop-product-gallery-item', function (e) {
                openPopup();
                setPopupContentByItemIndex($(this).data('item-index'));

                return false; // запрещаем переход по ссылке при открытии попапа
            });

            // управление с клавиатуры
            $(document).on('keydown', function(e) {
                if ($(document).find($popup).length) {
                    switch (e.key) {
                        case 'ArrowLeft':
                            prevMedia();
                            break;

                        case 'ArrowRight':
                            nextMedia();
                            break;

                        case ' ':
                            nextMedia();
                            break;

                        case 'Escape':
                            closePopup();
                            break;

                        default:
                            break;
                    }
                }
            });
        };

        init();

        return this;
    }
})(jQuery);